<template>
  <v-card outlined>
    <v-card-title class="subtitle-1 py-2">
      <template>
        <span class="pr-2">{{ title }}</span>
      </template>
    </v-card-title>
    <v-card-subtitle class="pt-1 pb-0">
      <span v-if="hasYearMakeOrModel" class="pr-2">{{ scheduleItem.description }}</span>
      <span v-else class="pr-2" />
    </v-card-subtitle>
    <v-card-text>
      <v-row wrap>
        <v-col class="pb-0" cols="4">
          <DisplayField label="ID / Serial #" :value="scheduleItem.serialNumber" />
        </v-col>
        <v-col class="pb-0" cols="4">
          <DisplayField label="Limit" :value="scheduleItem.limitOfInsurance" type="number" />
        </v-col>
        <v-col class="pb-0" cols="4">
          <DisplayField label="Premium" :value="scheduleItem.premium" type="currency" />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<style>
</style>

<script>
import DisplayField from '@/components/Shared/DisplayField.vue';
import scheduleItemHelper from '@/services/clientViewer/scheduleItemHelper.js';

export default {
  name: 'ScheduledItem',
  components: {
    DisplayField
  },
  props: {
    scheduleItem: {
      type: Object,
      required: true
    }
  },
  computed: {
    title: function () {
      return scheduleItemHelper.scheduleItemTitle(this.scheduleItem);
    },
    hasYearMakeOrModel: function () {
      return scheduleItemHelper.hasYearMakeOrModel(this.scheduleItem);
    }
  }
};
</script>
